import { render, staticRenderFns } from "./edit_item.vue?vue&type=template&id=61374a28&scoped=true"
import script from "./edit_item.vue?vue&type=script&lang=js"
export * from "./edit_item.vue?vue&type=script&lang=js"
import style0 from "./edit_item.vue?vue&type=style&index=0&id=61374a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61374a28",
  null
  
)

export default component.exports